import { useState } from 'react'
import {
  SINGLE_PLAYER_MODES, SINGLE_PLAYER_TIPS,
  MULTIPLAYER_MODES,
  PARTY_MODE_INTRO, PARTY_MODES, PARTY_MODE_TIPS,
} from '../utils/howToPlayContent'
import { IconBook, IconConfetti } from './icons'

/**
 * Full "How to Play" page — all three sections (Single Player, Multiplayer,
 * Party Mode) as expandable mode cards. Each mode tap toggles expand/collapse.
 *
 * Props:
 *   onBack — returns to wherever launched from (Settings or home)
 */
export default function HowToPlay({ onBack }) {
  return (
    <div className="how-to-play-page">
      <div className="screen-content">
        <h1 className="how-to-play-page__title">How to Play <IconBook size={20} style={{ verticalAlign: 'middle' }} /></h1>

        <Section title="Single Player">
          {SINGLE_PLAYER_MODES.map((m) => <ExpandableModeCard key={m.id} mode={m} />)}
          <ExpandableModeCard mode={SINGLE_PLAYER_TIPS} tip />
        </Section>

        <Section title="Multiplayer">
          {MULTIPLAYER_MODES.map((m) => <ExpandableModeCard key={m.id} mode={m} />)}
        </Section>

        <Section title={<><IconConfetti size={18} style={{ verticalAlign: 'middle' }} /> Party Mode</>}>
          <p className="how-to-play-page__intro">{PARTY_MODE_INTRO}</p>
          {PARTY_MODES.map((m) => <ExpandableModeCard key={m.id} mode={m} />)}
          <ExpandableModeCard mode={PARTY_MODE_TIPS} tip />
        </Section>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section className="how-to-play-section">
      <h2 className="how-to-play-section__title">{title}</h2>
      <div className="how-to-play-section__body">{children}</div>
    </section>
  )
}

export function ExpandableModeCard({ mode, tip }) {
  const [open, setOpen] = useState(false)
  return (
    <div className={`how-to-play-mode${open ? ' how-to-play-mode--open' : ''}${tip ? ' how-to-play-mode--tip' : ''}`}>
      <button
        type="button"
        className="how-to-play-mode__header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="how-to-play-mode__icon">{mode.Icon ? <mode.Icon size={20} /> : null}</span>
        <span className="how-to-play-mode__name">{mode.name}</span>
        {mode.cost && <span className="how-to-play-mode__cost">{mode.cost}</span>}
        <span className="how-to-play-mode__chevron" aria-hidden="true">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <ul className="how-to-play-mode__points">
          {mode.points.map((p, i) => <li key={i}>{p}</li>)}
        </ul>
      )}
    </div>
  )
}
